import { mApi } from "@/lib/api";

const base = "/merchant";

export const merchantCardsApi = {
  list: () => mApi.get(`${base}/cards`),
  /** Cardholder-scoped list (same as POST /api/v1/cards/list). */
  listForUser: (userId, { page, limit } = {}) =>
    mApi.post(
      `${base}/cards/list`,
      { user_id: userId },
      { params: { ...(page != null && { page }), ...(limit != null && { limit }) } },
    ),
  get: (id) => mApi.post(`${base}/cards/get`, { card_id: id }),
  cardTypes: () => mApi.get(`${base}/card-types`),
  products: (userId) => mApi.get(`${base}/cards/products`, { params: userId ? { user_id: userId } : {} }),
  users: () => mApi.get(`${base}/users`),
  apply: (body) => mApi.post(`${base}/cards/apply`, body),
  bind: (body) => mApi.post(`${base}/cards/bind`, body),
  detail: (cardId) => mApi.post(`${base}/cards/detail`, { card_id: cardId }),
  recharge: (cardId, amount) => mApi.post(`${base}/cards/recharge`, { card_id: cardId, amount }),
  rechargeFee: (cardId, amount) => mApi.post(`${base}/cards/recharge/fee`, { card_id: cardId, amount }),
  rechargeHistory: ({ card_id, page, limit } = {}) =>
    mApi.post(
      `${base}/cards/recharge/history`,
      card_id ? { card_id } : {},
      { params: { ...(page != null && { page }), ...(limit != null && { limit }) } },
    ),
  panHtml: (cardId) => mApi.post(`${base}/cards/pan-html`, { card_id: cardId }),
  pin: (cardId) => mApi.post(`${base}/cards/pin`, { card_id: cardId }),
  limits: (cardId) => mApi.post(`${base}/cards/limits`, { card_id: cardId }),
  updateEmail: (cardId, email) => mApi.post(`${base}/cards/email`, { card_id: cardId, email }),
  updatePhone: (cardId, dialCode, phoneNumber) =>
    mApi.post(`${base}/cards/phone`, { card_id: cardId, dial_code: dialCode, phone_number: phoneNumber }),
  bills: (body) => mApi.post(`${base}/cards/bills`, body),
  billDetail: (cardId, orderId) => mApi.post(`${base}/cards/bills/detail`, { card_id: cardId, order_id: orderId }),
  activate: (cardId, activeCode) => mApi.post(`${base}/cards/activate`, { card_id: cardId, active_code: activeCode }),
  order: (body) => mApi.post(`${base}/cards/order`, body),
  setFee: (cardId, cardFeeConfigList) =>
    mApi.post(`${base}/cards/fees/set`, { card_id: cardId, card_fee_config_list: cardFeeConfigList }),
  queryFee: (cardId) => mApi.post(`${base}/cards/fees/query`, { card_id: cardId }),
  respond3ds: (authId, approve) => mApi.post(`${base}/cards/3ds`, { auth_id: authId, approve }),
  freeze: (cardId, reason) => mApi.post(`${base}/cards/freeze`, { card_id: cardId, reason }),
  unfreeze: (cardId) => mApi.post(`${base}/cards/unfreeze`, { card_id: cardId }),
  terminate: (cardId, reason) => mApi.post(`${base}/cards/terminate`, { card_id: cardId, reason }),
};

export function errMsg(err) {
  return err?.response?.data?.detail || err?.message || "Request failed";
}
